import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M9.591 1.106a1.75 1.75 0 0 1 2.475 0l2.828 2.828a1.75 1.75 0 0 1 0 2.475l-1.413 1.414-5.657 5.657-1.415 1.414a1.75 1.75 0 0 1-2.475 0l-2.828-2.828a1.75 1.75 0 0 1 0-2.475L9.59 1.106ZM7.293 11.889l-.884-.884a.75.75 0 1 0-1.06 1.06l.883.885-.884.884a.25.25 0 0 1-.353 0l-2.829-2.829a.25.25 0 0 1 0-.353l8.486-8.486a.25.25 0 0 1 .353 0l2.829 2.829a.25.25 0 0 1 0 .353l-.884.884-.884-.884a.75.75 0 0 0-1.06 1.061l.883.884-.353.353-1.591-1.59a.75.75 0 0 0-1.061 1.06l1.59 1.591-.353.354-.884-.884a.75.75 0 0 0-1.06 1.06l.884.884-.354.354-1.59-1.591a.75.75 0 0 0-1.062 1.06l1.591 1.592-.353.353Z",
    "clip-rule": "evenodd"
  })
], -1), n = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), c = [
  o,
  n
];
function d(r, s) {
  return l(), t("svg", a, [...c]);
}
const h = { render: d };
export {
  h as default,
  d as render
};
